export const isPointsGroup = () => {
  // eslint-disable-next-line no-restricted-globals
  return location.origin.includes('.pointsgroup.');
}
